var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowsIconWhiteGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9935 37H9.49971C9.22471 37 8.99971 37.225 8.99971 37.5V41.25C8.99971 41.525 9.22471 41.75 9.49971 41.75H47.3247L38.306 53.1875C38.0497 53.5125 38.281 54 38.6997 54H43.231C43.5372 54 43.8247 53.8625 44.0185 53.6188L54.5685 40.2375C55.5997 38.925 54.6685 37 52.9935 37ZM54.4997 22.25H16.6747L25.6935 10.8125C25.9497 10.4875 25.7185 10 25.2997 10H20.7685C20.4622 10 20.1747 10.1375 19.981 10.3813L9.43096 23.7625C8.39971 25.075 9.33096 27 10.9997 27H54.4997C54.7747 27 54.9997 26.775 54.9997 26.5V22.75C54.9997 22.475 54.7747 22.25 54.4997 22.25Z",
    fill: "black",
    fillOpacity: 0.16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsIconWhiteGray);
export default __webpack_public_path__ + "static/media/arrows-icon-white-gray.f5b5807c3e4b7a622bb5aab4903ed4af.svg";
export { ForwardRef as ReactComponent };